import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import Flash from "../flash/Flash.jsx"
import { ThirdPartyApiNameByValue } from '../../repo/ThirdPartyApiRepo'

export default function AdminMatchesShow({match, tournament, status}) {
  const [flashMessage, setFlashMessage] = useState("")

  useEffect(() => {
    if (status === "created") {
      setFlashMessage("Match was successfully created")
    } else if (status === "updated") {
      setFlashMessage("Match was successfully updated")
    }

    window.history.replaceState(null, "Admin - Match" , '/cocofantoelefanto/tournaments/' + match.tournament_id + '/matches/' + match.id)
  }, [match, status])

  return(
    <>
      <h1>Show Match: {tournament.name} {tournament.edition}</h1>
      {flashMessage !== "" && (
        <Flash message={flashMessage} type="success"/>
      )}

      <div className="flex flex-col mt-4">
        <div key="match_match_score" className={`flex flex-row mt-4`}>
          <b>Jogo:</b>
          <span className="ml-4">{ match.team_a_name } { match.team_a_score } x { match.team_b_score } { match.team_b_name }</span>
        </div>

        <div key="match_stats_at" className={`flex flex-row mt-4`}>
          <b>Data-Hora UTC:</b>
          <span className="ml-4">{ match.starts_at }</span>
        </div>

        <div key="match_ended" className={`flex flex-row mt-4`}>
          <b>Finalizado:</b>
          <span className="ml-4">{ match.ended ? 'Sim' : 'Não' }</span>
        </div>

        <div key="match_group" className={`flex flex-row mt-4`}>
          <b>Grupo:</b>
          <span className="ml-4">{ match.group_name }</span>
        </div>

        <div key="match_phase" className={`flex flex-row mt-4`}>
          <b>Fase:</b>
          <span className="ml-4">{ match.phase }</span>
        </div>

        <div key="match_third_party_label" className={`flex flex-row mt-4`}>
          <b>API de terceiros:</b>
          <span className="ml-4">{ ThirdPartyApiNameByValue(match.third_party_label) }</span>
        </div>

        <div key="match_third_party_id" className={`flex flex-row mt-4`}>
          <b>ID de terceiros:</b>
          <span className="ml-4">{ match.third_party_id }</span>
        </div>

        <div key="match_is_demo" className={`flex flex-row mt-4`}>
          <b>Partida de demonstração:</b>
          <span className="ml-4">{ match.is_demo ? 'Sim' : 'Não' }</span>
        </div>
      </div>

      <div id="actions" className="w-full pt-4 mt-4 space-x-2">
        <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${match.tournament_id}/matches/${match.id}/edit`}>Edit Match</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${match.tournament_id}/matches`}>Back to Matches</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${match.tournament_id}/matches/new`}>Create New Match</Link>
      </div>

    </>
  )
}
